{
  "sdk-download-android": "Stáhnout pro Android",
  "sdk-connect": "Připojit",
  "sdk-download-ios": "Stáhnout pro iOS",
  "sdk-install": "Instalovat",
  "sdk-modal-instruct-1": "1. Otevřete aplikaci Binance",
  "sdk-modal-instruct-2": "2. Klepněte na {{icon}} na domovské obrazovce",
  "sdk-modal-title": "Připojit platformu Binance",
  "sdk-no-app": "Ještě nemáte aplikaci Binance?"
}